import { render, staticRenderFns } from "./LiquidationQuery.vue?vue&type=template&id=fe4171f0&scoped=true"
import script from "./LiquidationQuery.vue?vue&type=script&lang=js"
export * from "./LiquidationQuery.vue?vue&type=script&lang=js"
import style0 from "./LiquidationQuery.vue?vue&type=style&index=0&id=fe4171f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4171f0",
  null
  
)

export default component.exports